import { render, staticRenderFns } from "./ChannelDetailApp.vue?vue&type=template&id=22b6d98d&scoped=true"
import script from "./ChannelDetailApp.vue?vue&type=script&lang=js"
export * from "./ChannelDetailApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b6d98d",
  null
  
)

export default component.exports